/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';

import Fade from 'react-reveal/Fade';
import Header from 'parts/Header';
import EnterpriseSupport from 'parts/EnterpriseSupport';
import Discuss from 'parts/Discuss';
import Footer from 'parts/Footer';
import Button from 'elements/Button';

import Data from 'json/landingPage.json';

export default class SupportPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const supportFeatures = [
      {
        title: 'Post Deployment Infra Support',
        description: 'The actual success journey of a digital solution or product starts after the deployment. Once your new system goes live, it is crucial that you get a dedicated support team to ensure the maintenance, stability, and security of your product.',
        icon: '🔧',
      },
      {
        title: 'Extensive Warranty On Delivered Systems',
        description: 'After delivering your product, we offer you a warranty to ensure the longevity and quality of the product and that it works efficiently in the exact way it is intended to.',
        icon: '🛡️',
      },
      {
        title: '24/7 Dedicated Support Available',
        description: 'Under our 24/7 dedicated support model, we help you to manage your customer\'s/user\'s queries at any time including weekdays and holidays. This allows you to ensure that critical issues are addressed promptly, and minimize downtime or disruptions to the business operations.',
        icon: '🕐',
      },
      {
        title: 'Enterprise-grade SLA Compliances',
        description: 'We comply with all the Enterprise Grade Compliances which include information and outline the performance standards, guarantees, and obligations that we are dedicated to meet all the performance standards and obligations stated in the SLA.',
        icon: '📋',
      },
      {
        title: 'Tech support for system users',
        description: 'We provide you with assistance, guidance, and troubleshooting to help your system users effectively utilize, resolve issues and make the most of their technology investment.',
        icon: '👥',
      },
      {
        title: 'Hot Fix & Rapid Deployment Support',
        description: 'In order to resolve a critical issue immediately, we offer hotfixes and quick deployment support in the live production systems. This minimizes downtimes and ensures a smooth and continuous operation of your critical business applications.',
        icon: '⚡',
      },
      {
        title: 'In Office & On-Premises Support',
        description: 'We deliver personalized and on-site assistance to our clients through In-Office and On-Premises Support. We arrange dedicated support personnel for your office to meet your needs of immediate assistance, resolve technical issues, and offer training sessions to your in-house team and collaborative needs.',
        icon: '🏢',
      },
      {
        title: 'Technical implementation Support for Prod systems',
        description: 'We\'ve housed developers who have expertise and experience in implementing various technologies and systems. You can leverage their expertise to seek assistance for a seamless technology implementation process. Apart from this, System Integration, Configuration & Customization, Testing & Validation are the critical services we provide under EGS.',
        icon: '💼',
      },
      {
        title: 'Training and Manuals',
        description: 'We can also provide Training and Manuals as part of EGS to empower your organization with all the knowledge and resources required to use the software solutions. By using the user manuals, you can guide your users with the instructions to use the software effectively. Moreover, we also draft technical documentation, which provides detailed information about the software architecture, system requirements, APIs, integrations, and advanced customization options. This allows your technical team to gain a deeper understanding of the software and its underlying technical aspects.',
        icon: '📚',
      },
      {
        title: 'On Call, On Chat and Ticket Based Support Processes',
        description: 'Our On-call, On-chat, and Ticket-based support allow your enterprise to have multiple channels to seek assistance and technical support to resolve issues promptly.',
        icon: '📞',
      },
    ];

    return (
      <>
        <Header {...this.props} />
        <section className="pt-32 pb-16 bg-gradient-to-b from-white to-gray-50">
          <div className="container mx-auto px-4">
            <Fade bottom>
              <h1 className="text-5xl lg:text-6xl text-theme-blue text-center font-bold mb-4">
                Enterprise Support
              </h1>
              <h2 className="text-3xl lg:text-4xl text-theme-blue text-center font-semibold mb-4">
                ExtensiveCustomer Support
              </h2>
              <p className="font-light text-lg lg:text-xl text-gray-600 text-center mb-12 max-w-3xl mx-auto">
                For Startups To Enterprise Grade
              </p>
              <p className="font-light text-base lg:text-lg text-gray-600 text-center mb-8 max-w-4xl mx-auto leading-relaxed">
                ERapid Technologies offers you enterprise-grade support which includes
                comprehensive and specialized technical support and assistance for your
                large-scale enterprise-level software. We have designed our enterprise-grade
                support to meet the unique needs and challenges faced by large-size organizations
                which are dependent on complex software solutions for their day-to-day operations.
                Additionally Startups have a different type of support needs in their rapidly
                changing deployments, we have specialized teams trained to cater the same as well.
              </p>
            </Fade>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {supportFeatures.map((feature, index) => (
                <Fade bottom delay={200 * index} key={feature.title}>
                  <div className="bg-white rounded-xl shadow-md border border-gray-100 p-6 transform transition-all duration-300 hover:shadow-xl hover:scale-105 h-full">
                    <div className="text-4xl mb-4">{feature.icon}</div>
                    <h3 className="text-xl font-semibold text-theme-blue mb-3">
                      {feature.title}
                    </h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </Fade>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <Fade bottom>
              <div className="text-center">
                <h2 className="text-3xl lg:text-4xl text-theme-blue font-bold mb-4">
                  Choose ERapid Technologies for Seamless
                </h2>
                <p className="text-xl text-theme-blue font-semibold mb-8">
                  Large-Scale Operations and Tailored Support.
                </p>
                <Button
                  href="/contact"
                  type="link"
                  className="inline-flex items-center px-8 py-3 bg-gradient-to-r from-theme-purple to-dark-theme-purple text-white rounded-lg shadow-lg hover:shadow-xl transform transition-all duration-300 hover:scale-105"
                >
                  Contact Us
                  <svg className="ml-2 w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </Button>
              </div>
            </Fade>
          </div>
        </section>

        <EnterpriseSupport data={Data.enterpriseSupport} />
        <Discuss {...this.props} />
        <Footer />
      </>
    );
  }
}
